/** Utilidades compartidas entre SalesReport y subvistas (evita recrear funciones en cada render). */

export const CATEGORY_COLORS = [
  '#4299e1',
  '#48bb78',
  '#ed8936',
  '#805ad5',
  '#e53e3e',
  '#38b2ac',
  '#d69e2e',
  '#dd6b20',
  '#f97316',
  '#22c55e',
  '#6366f1',
  '#ec4899',
  '#14b8a6',
  '#7c3aed',
  '#0ea5e9',
];

export const PRODUCT_COLORS = [
  '#6366f1',
  '#f59e0b',
  '#10b981',
  '#ef4444',
  '#3b82f6',
  '#ec4899',
  '#22c55e',
  '#a855f7',
  '#0ea5e9',
  '#f97316',
  '#15803d',
  '#7c3aed',
  '#14b8a6',
  '#e11d48',
  '#7dd3fc',
  '#65a30d',
  '#facc15',
  '#db2777',
];

const stringToIndex = (str, modulo) => {
  const s = String(str || '');
  let hash = 0;
  for (let i = 0; i < s.length; i += 1) {
    hash = (hash * 31 + s.charCodeAt(i)) | 0;
  }
  const idx = Math.abs(hash) % modulo;
  return idx;
};

export const getCategoryColor = (name) =>
  CATEGORY_COLORS[stringToIndex(name || 'Sin categoría', CATEGORY_COLORS.length)];

export const getProductColor = (name) =>
  PRODUCT_COLORS[stringToIndex(name || 'Producto', PRODUCT_COLORS.length)];

export const formatCurrency = (value) =>
  value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });

export const formatPercentage = (value) => `${value.toFixed(2)}%`;

export const formatDateRangeDisplay = (dateStr) => {
  if (!dateStr) return '—';
  const [y, m, d] = String(dateStr).split('-');
  return d && m && y ? `${d}/${m}/${y}` : dateStr;
};

export const formatDateForLabel = (date) => {
  if (!date || !(date instanceof Date) || isNaN(date.getTime())) return '—';
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

export const getDayName = (dayNumber) => {
  const days = ['Domingo', 'Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado'];
  return days[dayNumber];
};
